import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../../../useApiMutation';
import useMessage from '../../../../useMessage';

const useCreateMarketplaceProfile = () => {
  const { message } = useMessage();

  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId }) => `/shows/${showId}/marketplace/profiles/hosts`,
    method: 'POST',
    onSuccess: (data) => {
      queryClient.invalidateQueries(keys.hostProfiles({ showId: data.showId }));
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while creating marketplace profile." />
        ),
      });
    },
  });

  return {
    createHostProfile: mutation.mutate,
    isCreateHostProfileLoading: mutation.isLoading,
    isCreateHostProfileError: mutation.isError,
    isCreateHostProfileSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useCreateMarketplaceProfile;
